import { defineComponent as b, mergeModels as r, useModel as c, provide as t, computed as s, createBlock as y, openBlock as C, resolveDynamicComponent as k, mergeProps as B, unref as l, withCtx as h, renderSlot as v } from "vue";
import e from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Card/card.js";
import { isDefined as g } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { useOUIAProps as x } from "../../helpers/ouia.js";
const S = Symbol("CardExpandedKey"), I = Symbol("CardExpandableKey"), K = Symbol("CardCheckboxKey"), D = /* @__PURE__ */ b({
  name: "PfCard",
  inheritAttrs: !1,
  __name: "Card",
  props: /* @__PURE__ */ r({
    component: { default: "div" },
    compact: { type: Boolean },
    selectable: { type: Boolean },
    selectableInput: { type: [Boolean, String] },
    name: {},
    clicked: { type: Boolean },
    large: { type: Boolean },
    fullHeight: { type: Boolean },
    plain: { type: Boolean },
    expandable: { type: Boolean },
    disabled: { type: Boolean },
    variant: {},
    onClick: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: void 0 },
    expandedModifiers: {},
    selected: { type: Boolean, default: !1 },
    selectedModifiers: {}
  }),
  emits: /* @__PURE__ */ r(["change"], ["update:expanded", "update:selected"]),
  setup(d, { emit: p }) {
    const a = d, m = x({ id: a.ouiaId, safe: a.ouiaSafe }), i = c(d, "expanded"), n = c(d, "selected"), f = p;
    t(S, i), t(I, s(() => a.expandable || g(i.value))), t(K, s(() => !a.selectableInput && !a.name ? null : {
      name: a.name,
      hidden: a.selectableInput !== "visible",
      checked: n,
      disabled: a.disabled,
      onChange: (o) => f("change", o)
    }));
    const u = s(() => a.selectable && a.onClick ? [
      e.modifiers.selectable,
      e.modifiers.clickable,
      (n.value || a.clicked) && e.modifiers.current
    ] : a.selectable ? [e.modifiers.selectable, n.value && e.modifiers.selected] : a.onClick ? [e.modifiers.clickable, a.clicked && e.modifiers.current] : []);
    return (o, M) => (C(), y(k(o.component), B({ ...l(m), ...o.$attrs }, {
      class: [l(e).card, ...u.value, {
        [l(e).modifiers.compact]: o.compact,
        [l(e).modifiers.expanded]: i.value,
        [l(e).modifiers.displayLg]: o.large && !o.compact,
        [l(e).modifiers.fullHeight]: o.fullHeight,
        [l(e).modifiers.plain]: o.plain,
        [l(e).modifiers.secondary]: o.variant === "secondary",
        [l(e).modifiers.disabled]: o.disabled
      }],
      tabindex: o.selectable ? "0" : void 0,
      onClick: o.onClick
    }), {
      default: h(() => [
        v(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["class", "tabindex", "onClick"]));
  }
});
export {
  K as CardCheckboxKey,
  I as CardExpandableKey,
  S as CardExpandedKey,
  D as default
};
